(() => {
  const dropdowns = Array.from(document.querySelectorAll('[data-sa-sort-dropdown]'));
  if (dropdowns.length === 0) return;

  const getParts = (dropdown) => ({
    select: dropdown.querySelector('select[name="sort_by"]'),
    trigger: dropdown.querySelector('[data-sa-sort-trigger]'),
    current: dropdown.querySelector('[data-sa-sort-current]'),
    menu: dropdown.querySelector('[data-sa-sort-menu]'),
    options: Array.from(dropdown.querySelectorAll('[data-sa-sort-option]')),
  });

  const closeDropdown = (dropdown, returnFocus = false) => {
    const { trigger, menu } = getParts(dropdown);
    dropdown.classList.remove('is-open');
    trigger?.setAttribute('aria-expanded', 'false');
    if (menu) menu.hidden = true;
    if (returnFocus) trigger?.focus({ preventScroll: true });
  };

  const closeOthers = (activeDropdown) => {
    dropdowns.forEach((dropdown) => {
      if (dropdown !== activeDropdown) closeDropdown(dropdown);
    });
  };

  const syncDropdown = (dropdown) => {
    const { select, current, options } = getParts(dropdown);
    if (!select) return;

    const selectedOption = select.options[select.selectedIndex];
    if (current && selectedOption) current.textContent = selectedOption.textContent.trim();

    options.forEach((option) => {
      option.setAttribute('aria-selected', option.dataset.sortValue === select.value ? 'true' : 'false');
    });
  };

  const openDropdown = (dropdown, focusDirection = 'selected') => {
    const { trigger, menu, options } = getParts(dropdown);
    if (!trigger || !menu) return;

    closeOthers(dropdown);
    dropdown.classList.add('is-open');
    trigger.setAttribute('aria-expanded', 'true');
    menu.hidden = false;

    const selectedIndex = Math.max(0, options.findIndex((option) => option.getAttribute('aria-selected') === 'true'));
    const focusIndex = focusDirection === 'last' ? options.length - 1 : selectedIndex;
    window.requestAnimationFrame(() => options[focusIndex]?.focus({ preventScroll: true }));
  };

  dropdowns.forEach((dropdown) => {
    const { select, trigger, menu, options } = getParts(dropdown);
    if (!select || !trigger || !menu || options.length === 0) return;

    syncDropdown(dropdown);

    trigger.addEventListener('click', () => {
      if (dropdown.classList.contains('is-open')) {
        closeDropdown(dropdown);
      } else {
        openDropdown(dropdown);
      }
    });

    trigger.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        event.preventDefault();
        openDropdown(dropdown, event.key === 'ArrowUp' ? 'last' : 'selected');
      }
    });

    options.forEach((option, optionIndex) => {
      option.addEventListener('click', () => {
        const nextValue = option.dataset.sortValue || '';
        const changed = select.value !== nextValue;
        select.value = nextValue;
        syncDropdown(dropdown);
        closeDropdown(dropdown, true);

        if (changed) {
          select.dispatchEvent(new Event('input', { bubbles: true }));
        }
      });

      option.addEventListener('keydown', (event) => {
        let nextIndex = optionIndex;

        if (event.key === 'ArrowDown') nextIndex = (optionIndex + 1) % options.length;
        else if (event.key === 'ArrowUp') nextIndex = (optionIndex - 1 + options.length) % options.length;
        else if (event.key === 'Home') nextIndex = 0;
        else if (event.key === 'End') nextIndex = options.length - 1;
        else if (event.key === 'Escape') {
          event.preventDefault();
          closeDropdown(dropdown, true);
          return;
        } else if (event.key === 'Tab') {
          closeDropdown(dropdown);
          return;
        } else {
          return;
        }

        event.preventDefault();
        options[nextIndex]?.focus({ preventScroll: true });
      });
    });

    select.addEventListener('change', () => syncDropdown(dropdown));
  });

  document.addEventListener('click', (event) => {
    dropdowns.forEach((dropdown) => {
      if (!dropdown.contains(event.target)) closeDropdown(dropdown);
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    dropdowns.forEach((dropdown) => {
      if (dropdown.classList.contains('is-open')) closeDropdown(dropdown, true);
    });
  });

  window.addEventListener('pageshow', () => dropdowns.forEach(syncDropdown));
})();
